import React from "react";
import StaffLogin from "./StaffLogin";

export default function FinanceLogin() {
  return <StaffLogin role="finance" redirectTo="/finance/dashboard"
    title="Finance" subtitle="Manage and disburse partner payouts." accent="amber" />;
}
